import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';
import { AdminComponent } from './layout/admin/admin.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BreadcrumbsComponent } from './layout/admin/breadcrumbs/breadcrumbs.component';
import { TitleComponent } from './layout/admin/title/title.component';
import { AuthComponent } from './layout/auth/auth.component';
import { AuthGuard } from './guards/auth.guard';
import { AuthenticationService } from './services/authentication.service';
import { InvoiceService } from './services/invioce.services';
import { JobService } from './services/jobs.services';
import { MechanicService } from './services/mechanic.services';
import { VehicleServices } from './services/vechicle.services';
import { TimeSheetService } from './services/timesheet.services';
import { SysUserService } from './services/sysusers.services';
import { JobTemplateService } from './services/jobtemplate.services';
import { JobScheduleService } from './services/jobschedule.services';
import { CustomerServices } from './services/customer.services';
import { SpeechService } from './services/speech.service';
import { QuoteService } from './services/quote.services';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgxSpinnerModule } from 'ngx-spinner';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgSlimScrollModule } from 'ngx-slimscroll';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { ToastrModule } from 'ngx-toastr';
import { ClickOutsideModule } from './directives/ng2-click-outside.module';

@NgModule({
  schemas: [NO_ERRORS_SCHEMA],
  declarations: [
    AppComponent,
    AdminComponent,
    BreadcrumbsComponent,
    TitleComponent,
    AuthComponent,
    NumberOnlyDirective
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes),
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
    SharedModule,
    FormsModule,
    HttpClientModule,
    NgxSpinnerModule,
    UiSwitchModule,
    NgSlimScrollModule,
    ClickOutsideModule,
    ToastrModule.forRoot()
  ],
  providers: [
    AuthGuard,
    AuthenticationService,
    InvoiceService,
    JobService,
    MechanicService,
    VehicleServices,
    TimeSheetService,
    SysUserService,
    JobTemplateService,
    JobScheduleService,
    CustomerServices,
    SpeechService,
    QuoteService,
    provideClientHydration()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }